import React from "react";
import PropTypes from "prop-types";
import {
  ComposableMap,
  ZoomableGroup,
  Geographies,
  Geography
} from "react-simple-maps";
import { css } from "react-emotion";
import { darken, saturate } from "polished";

import Tooltip from "./Tooltip";
import montanaCounties from "../data/montana-counties.json";
import { colors } from "../consts";

const transitionDuration = 0.3;
const rsmStyles = css`
  .rsm-geography {
    transition: fill ${transitionDuration}s;
  }
`;

export default class MTMap extends React.Component {
  static propTypes = {
    indicatorData: PropTypes.object.isRequired,
    hoveredCounty: PropTypes.string,
    setHoveredCounty: PropTypes.func.isRequired
  };

  openDataSheet = () => {
    window.open(this.props.dataSheetUrl, "_blank");
  };

  render() {
    const { indicatorData, setHoveredCounty, hoveredCounty } = this.props;
    return (
      <React.Fragment>
        <ComposableMap
          className={rsmStyles}
          projection="mercator"
          projectionConfig={{
            scale: 3400
          }}
          width={980}
          height={551}
          style={{
            width: "100%",
            height: "auto"
          }}
        >
          <ZoomableGroup center={[-108, 47]} zoom={1} disablePanning>
            <Geographies geography={montanaCounties} disableOptimization>
              {(geographies, projection) =>
                geographies.map((geography, i) => {
                  // NOTE: I can use this to match it up to the data JSON and
                  // control style.
                  //
                  // Should be able to use chroma-js and d3-scale to control color
                  // See https://github.com/zcreativelabs/react-simple-maps/blob/master/examples/switching-between-datasets/pages/index.js
                  //
                  // Can use onMouseEnter, onMouseLeave, and onClick on Geography
                  // to control state for tooltips, highlights, etc.
                  const name = geography.properties.NAME;
                  const hovered = name === hoveredCounty;
                  // console.log(name);
                  const countyData = indicatorData.counties[`${name} County`];
                  const fillColor = countyData.value
                    ? indicatorData.colorScale(countyData.value)
                    : colors.empty;
                  const hoveredFillColor = saturate(
                    0.2,
                    darken(0.2, fillColor)
                  );
                  return (
                    geography.id !== "ATA" && (
                      <Geography
                        key={name}
                        data-tip={`
                          <div>
                            <div class="tooltip-wrapper">
                              <h4 class="tooltip-name">${name} County</h4>
                              <h4 class="tooltip-value">${
                                countyData.valueString
                              }</h4>

                            </div>
                            <h5 class="tooltip-download mt">Click to download Data Sheet (PDF)</h5>
                          </div>
                        `}
                        onMouseEnter={({ properties }, e) => {
                          // give onMouseLeave event's setState time to finish
                          setTimeout(() => {
                            setHoveredCounty(properties.NAME);
                          }, 10);
                        }}
                        onMouseLeave={({ properties }, e) => {
                          setHoveredCounty(null);
                        }}
                        onClick={this.openDataSheet}
                        geography={geography}
                        projection={projection}
                        style={{
                          default: {
                            fill: hovered ? hoveredFillColor : fillColor,
                            stroke: "#ffffff",
                            strokeWidth: hovered ? 3 : 0.75,
                            outline: "none",
                            cursor: "pointer"
                          },
                          hover: {
                            fill: hoveredFillColor,
                            stroke: "#ffffff",
                            strokeWidth: 3,
                            outline: "none",
                            cursor: "pointer"
                          },
                          pressed: {
                            fill: hoveredFillColor,
                            stroke: "#ffffff",
                            strokeWidth: 0.75,
                            outline: "none",
                            cursor: "pointer"
                          }
                        }}
                      />
                    )
                  );
                })
              }
            </Geographies>
          </ZoomableGroup>
        </ComposableMap>

        <Tooltip />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MTMap.js